<template>
  <a :href="props.href" @click="onClick($event)"><slot></slot></a>
</template>

<script lang="ts" setup>
import { redirect } from "@/utils/redirect";
import { isLoggedIn, openLoginModal } from "./store";

const props = defineProps<{
  href: string;
}>();

const onClick = async ($event: Event): Promise<void> => {
  if (!isLoggedIn.value) {
    $event.preventDefault();

    const isLogged = await openLoginModal();
    if (isLogged) {
      redirect(props.href);
    }
  }
};
</script>
